export enum BadgeFilterSubscriptionTypeEmum {
  Empty = 'EMPTY'
}
